export const SET_SESSION_TIMEOUT_TIME = "SET_SESSION_TIMEOUT_TIME";